module.exports = __webpack_public_path__ + "img/nginxwise2.e0232399.png";